import { useLayoutEffect, useRef } from "react"
import SliderImg from "./SliderImg"
import data from "../data/project.json"
import gsap from "gsap"
import ScrollTrigger from "gsap/ScrollTrigger"

const Slider = () => {
  const sliderRef = useRef(null)

  useLayoutEffect(() => {
    gsap.registerPlugin(ScrollTrigger)
    const ctx = gsap.context(() => {
      let slides = gsap.utils.toArray(".slider-img")
      gsap.to(slides, {
        xPercent: () =>
          window.innerWidth > 500
            ? -100 * (slides.length - 1)
            : -103 * (slides.length - 1),
        ease: "none",
        scrollTrigger: {
          trigger: sliderRef.current,
          pin: true,
          scrub: 1,
          snap: 1 / (slides.length - 1),
          start: () => "-=" + sliderRef.current.offsetTop,
          end: () => `${sliderRef.current?.offsetWidth} bottom`,
          invalidateOnRefresh: true,
          refreshPriority: 1,
        },
      })
    }, sliderRef.current)

    return () => {
      ctx.revert() // animation cleanup!!
    }
  }, [])

  return (
    <div ref={sliderRef} className="slider">
      {data?.projects.slice(0, 5).map((proj) => (
        <SliderImg key={proj.title} proj={proj} />
      ))}
    </div>
  )
}

export default Slider
